/**
 * GM Shop — correctif bannière cookies Shopify (Customer Privacy).
 * Le thème CSS ne suffit pas quand Shopify utilise un shadow root ou des styles inline.
 * Ce script injecte du CSS dans le shadow DOM et/ou applique des inline !important.
 */
(function () {
  'use strict';

  var GM_MARKER = 'data-gm-cookie-prefs-fixed';

  var CSS_TEXT =
    '#shopify-pc__banner,#shopify-pc__banner *{box-sizing:border-box}' +
    '#shopify-pc__banner{overflow:visible!important;max-height:none!important;clip-path:none!important}' +
    '[id*="btn-prefs"],[id*="prefs"],button[id*="prefs"],a[id*="prefs"],' +
    '.shopify-pc__banner__btn-wrapper>a:first-child,' +
    'button.shopify-pc__banner-btn-manage-preferences,' +
    'a[class*="manage"],button[class*="manage"],button[class*="Manage"]{' +
    'text-decoration:none!important;text-decoration-line:none!important;' +
    '-webkit-text-decoration:none!important;color:#fff!important;' +
    '-webkit-text-fill-color:#fff!important;opacity:1!important;' +
    'border:0!important;border-bottom:2px solid #7cc4ff!important;' +
    'border-radius:0!important;background:transparent!important;' +
    'background-image:none!important;box-shadow:none!important;' +
    'filter:none!important;text-shadow:none!important;font-weight:500!important;' +
    '}' +
    '[id*="btn-prefs"]:hover,a[class*="manage"]:hover,button[class*="manage"]:hover{' +
    'color:#7cc4ff!important;-webkit-text-fill-color:#7cc4ff!important;' +
    'border-bottom-color:#7cc4ff!important}';

  function injectStyleIntoShadow(shadowRoot) {
    if (!shadowRoot || shadowRoot.querySelector('style[data-gm-cookie-banner]')) return;
    var s = document.createElement('style');
    s.setAttribute('data-gm-cookie-banner', '1');
    s.textContent = CSS_TEXT;
    shadowRoot.prepend(s);
  }

  function inlineFix(el) {
    if (!el || el.getAttribute(GM_MARKER) === '1') return;
    var accept =
      el.matches &&
      (el.matches('.shopify-pc__banner-btn-accept') ||
        el.matches('.shopify-pc__banner__btn-accept') ||
        el.matches('.shopify-pc__banner-btn-decline') ||
        el.matches('.shopify-pc__banner__btn-decline') ||
        el.matches('[class*="btn-accept"]') ||
        el.matches('[class*="btn-decline"]'));
    if (accept) return;

    el.setAttribute(GM_MARKER, '1');
    var p = function (prop, val) {
      try {
        el.style.setProperty(prop, val, 'important');
      } catch (e) {
        /* ignore */
      }
    };
    p('text-decoration', 'none');
    p('text-decoration-line', 'none');
    p('-webkit-text-decoration', 'none');
    p('color', '#ffffff');
    p('-webkit-text-fill-color', '#ffffff');
    p('opacity', '1');
    p('border', '0');
    p('border-bottom', '2px solid #7cc4ff');
    p('border-radius', '0');
    p('background', 'transparent');
    p('background-image', 'none');
    p('box-shadow', 'none');
    p('filter', 'none');
    p('text-shadow', 'none');
  }

  function findPrefsCandidates(root) {
    var list = [];
    var q = function (sel) {
      try {
        var n = root.querySelectorAll(sel);
        for (var i = 0; i < n.length; i++) list.push(n[i]);
      } catch (e) {
        /* invalid selector in old browsers */
      }
    };
    q('#shopify-pc__banner__btn-prefs');
    q('[id*="btn-prefs"]');
    q('[id*="prefs"]');
    q('button.shopify-pc__banner-btn-manage-preferences');
    q('a.shopify-pc__banner__btn-prefs');
    var wrap = root.querySelector('.shopify-pc__banner__btn-wrapper');
    if (wrap && wrap.firstElementChild) {
      var fe = wrap.firstElementChild;
      if (fe.tagName === 'A' || fe.tagName === 'BUTTON') list.push(fe);
    }
    // Libellé FR/EN — cible « Gérer vos préférences » même si les classes changent
    try {
      var elements = root.querySelectorAll('a,button');
      for (var j = 0; j < elements.length; j++) {
        var el = elements[j];
        var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (!t) continue;
        if (
          /(gérer|manage).*(pr[eé]f[eé]rence|preference)|pr[eé]f[eé]rence/i.test(t) &&
          !/(accepter|accept|tout|refuser|decline)/i.test(t)
        ) {
          list.push(el);
        }
      }
    } catch (e2) {
      /* ignore */
    }
    return list;
  }

  function fixBannerHost(host) {
    if (!host) return;
    host.style.setProperty('overflow', 'visible', 'important');
    host.style.setProperty('max-height', 'none', 'important');

    if (host.shadowRoot) {
      injectStyleIntoShadow(host.shadowRoot);
      findPrefsCandidates(host.shadowRoot).forEach(inlineFix);
    }
    findPrefsCandidates(host).forEach(inlineFix);
  }

  function scan() {
    var hosts = document.querySelectorAll(
      '#shopify-pc__banner, [id^="shopify-pc__banner"], shopify-consent-banner, [is="shopify-consent-banner"]'
    );
    for (var i = 0; i < hosts.length; i++) fixBannerHost(hosts[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  var obs = new MutationObserver(function () {
    scan();
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
